import { getApp, getApps, initializeApp } from "firebase/app";
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signOut,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDV1JIVLF9LAc3-MllfLuCoBuyhhTJ5nEE",
  authDomain: "stampikz.firebaseapp.com",
  projectId: "stampikz",
  storageBucket: "stampikz.appspot.com",
  messagingSenderId: "528633920486",
  appId: "1:528633920486:web:96cc402eac537dd51e7427",
  measurementId: "G-42CTJTYK0R",
};

// Reuse the initialized app during development hot reloads.
const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(firebaseApp);

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

export function signInWithGoogle() {
  return signInWithPopup(auth, googleProvider);
}

export function signOutUser() {
  return signOut(auth);
}
